import { render, staticRenderFns } from "./DocumentPortalWelcome.vue?vue&type=template&id=7fa31652&"
import script from "./DocumentPortalWelcome.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalWelcome.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports